import { createIrisApiClient, basePaths } from 'API/clients/iris/irisapi'
import { filterParamSerializer } from 'API/utilities/filterParamSerializer'

const irisApiClient = createIrisApiClient(basePaths.iris)
const baseInspectionInstancePath = 'inspection-instance'
const baseInspectionInstancesPath = 'inspection-instances'

const getInspectionsFiltered = (params?) => {
  return irisApiClient.get(`/${baseInspectionInstancesPath}/`, {
    params,
    paramsSerializer: filterParamSerializer,
  })
}

const workcards = (inspectionInstanceUUID) =>
  irisApiClient.get(`/${baseInspectionInstancePath}/${inspectionInstanceUUID}/workcards/`)

const updateInspectionInstanceLabel = (uuid: string, label: string) => {
  return irisApiClient.patch(`/${baseInspectionInstancePath}/${uuid}/label/`, { label })
}

export { getInspectionsFiltered, workcards, updateInspectionInstanceLabel }
